import React from 'react';
import { Hero } from './Hero';
import { Capabilities } from './Capabilities';
import { CTA } from './CTA';
export function WebDevelopment() {
  return <div className="min-h-screen w-full bg-white" data-id="element-615">
      <Hero data-id="element-616" />
      <Capabilities data-id="element-617" />
      <CTA data-id="element-618" />
    </div>;
}